
import React, { FunctionComponent } from 'react';
import ReactDOM from 'react-dom/client';
import {
  createStore,
  applyMiddleware,
  compose,
} from 'redux';
import { Provider } from 'react-redux';
import thunkMiddleware from 'redux-thunk';
import { BrowserRouter } from 'react-router-dom';
import { appConfig } from '../../../config';
import { rootReducer } from '../../../reducers';
import createApiMiddleware from '../../../middleware/api';
import { envs } from '../../../config/index';
import { awsWafUrl, luckyOrangeUrl } from "config";
import { AxiosWrapper } from 'components/ezpay/common/axios-wrapper/axios-wrapper';

// @ts-ignore
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && process.env.REACT_APP_ENV !== envs.PRODUCTION ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;

const store = createStore(
  rootReducer,
  {},
  composeEnhancers(
    applyMiddleware(
      thunkMiddleware,
      createApiMiddleware(),
    ),
  ),
)

async function injectAwsWafScript() {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = awsWafUrl;
    script.async = true;
    script.onload = () => resolve("");
   // script.onerror = () => reject(new Error(`Failed to load AWS WAF script`));
    script.onerror = () => resolve(""); // Ignore error and resolve to continue loading the page
    document.head.appendChild(script);
  });
}

async function injectLoScript() {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = luckyOrangeUrl;
    script.async = true;
    script.onload = () => resolve("");
    script.onerror = () => resolve(""); // Ignore error and resolve to continue loading the page
    document.head.appendChild(script);
  });
}

const basePath = appConfig.basePath;

/**
 * Export a function that takes an App component, and wraps it with the redux store provider and a
 * router before rendering
 */
// eslint-disable-next-line import/no-anonymous-default-export
export default async (appComponent: FunctionComponent, containerId = 'root') => {
  await injectAwsWafScript();

  //Inject Lucky Orange script only in production environment
  // This is to avoid the site-id being reused in dev and qa environments
  if (process.env.REACT_APP_ENV === envs.PRODUCTION)
    await injectLoScript();

  const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
  root.render(
    /* @ts-ignore */
    <Provider store={store}>
      <AxiosWrapper>
        {/* @ts-ignore */}
        <BrowserRouter basename={basePath}>
          {React.createElement(appComponent)}
        </BrowserRouter>
      </AxiosWrapper>
    </Provider>
  );
};
